export default {
  title: 'Mi restaurante | Mis restaurantes',
  buttons: {
    actions: {
      reset: 'Borrar',
      cancel: 'Cancelar',
      save: 'Aceptar'
    }
  },
  labels: {
    range: 'Rango de fechas',
    filters: 'Filtros'
  },
  tablePurchaseReport: {
    title: 'Compras',
    loadingMessage: 'Cargando compras...',
    headers: {
      name: 'Compras',
      subtotal: 'Subtotal',
      subtotalNotIva: 'Subtotal 0%',
      subtotalIva: 'Subtotal 16%',
      iva: 'Iva',
      ieps: 'Ieps',
      total: 'Total',
      actions: 'Acciones'
    },
    noData: 'No se encontraron compras',
    footerText: 'filas por página'
  },
  tooltips: {
    exportCSV: 'Descargar CSV',
    downloadXML: 'Descargar XMLS'
  },
  placeholders: {
  },
  alerts: {
  },
  validations: {
  },
  tabs: {
    income: 'Ingresos',
    purchases: 'Compras',
    expenses: 'Gastos',
    result: 'Resultados'
  },
  incomeReport: {
    table: {
      loadingText: 'Cargando reportes...',
      headers: {
        income: 'Ingreso',
        subtotal: 'Subtotal',
        tax: 'IVA',
        total: 'Total',
        actions: 'Acciones'
      },
      downloadReport: 'Descargar reporte',
      downloadXML: 'Descargar XMLS',
      downloadInvoice: 'Descargar factura',
      incomes: {
        invoicePosTotal: 'Venta factura global',
        customerInvoicedTotal: 'Venta factura clientes',
        otherSalesWithInvoice: 'Otras ventas con factura',
        globalTotal: 'Total',
        transactionsWithInvoice: 'Cobranza',
        transactionsWithoutInvoice: 'Cobranza sin factura',
        uncollectedInvoices: 'Facturas sin cobrar',
        incomeTypes: 'Ingresos por categoría'
      }
    }
  },
  expensesReport: {
    buttonOther: 'Ver facturas sin pagar y/o pagos sin soporte',
    table: {
      loadingText: 'Cargando reportes...',
      headers: {
        expense: 'Gasto',
        category: 'Categoría',
        subtotal: 'Subtotal',
        tax: 'IVA',
        total: 'Total',
        discount: 'Descuento',
        actions: 'Acciones'
      },
      downloadReport: 'Descargar reporte',
      downloadXML: 'Descargar XMLS',
      expenses: {
        invoicedInMonth: 'Facturado en el mes',
        monthlyTransactions: 'Transacciones bancarias del mes',
        payOrdersReceived: 'Ódenes de pago facturadas',
        paidOrders: 'Órdenes de pago pagadas',
        pendingPaymentOrders: 'Facturas sin pagar acumuladas',
        ordersWithoutSupport: 'Pagos sin soporte',
        outgoingCategories: 'Egresos por categoría'
      }
    }
  },
  resultReport: {
    buttonGenerate: 'Generar resultados del mes',
    table: {
      loadingText: 'Cargando reportes...',
      headers: {
        month: 'Mes',
        sale: 'Venta',
        collection: 'Cobro',
        purchase: 'Compra',
        paidPurchase: 'Compra pagada',
        expense: 'Gasto',
        paidExpense: 'Gasto pagado',
        result: 'Resultado',
        flow: 'Flujo'
      },
      downloadReport: 'Descargar reporte',
      updateReport: 'Actualizar reporte'
    },
    otherResultReportsPanel: {
      title: 'Facturas sin pagar y/o pagos sin soporte',
      table: {
        loadingText: 'Cargando reportes...',
        headers: {
          paymentDate: 'Fecha de pago',
          paymentOrder: 'Orden de pago o anticipo',
          amount: 'Monto total',
          invoice: 'Soporte o factura',
          invoiceDate: 'Fecha factura',
          id: 'Folio fiscal',
          status: 'Estatus',
          accountStatus: 'Estatus contabilidad'
        },
        downloadReport: 'Descargar reporte',
        viewInvoice: 'Ver factura'
      }
    }
  }
}
